import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";

@Component({
    selector: 'app-menu-admin',
    template: `
        <div class="card" style="width: 100%;">
            <ul class="list-group list-group-flush">
                <li (click)="changeActiveMenu(1)" [ngClass]="{'active': activeMenu == 1}" class="list-group-item">Produits</li>
                <li (click)="changeActiveMenu(2)" [ngClass]="{'active': activeMenu == 2}" class="list-group-item">Catégories</li>
                <li (click)="changeActiveMenu(3)" [ngClass]="{'active': activeMenu == 3}" class="list-group-item">Formules</li>
                <!--<li (click)="changeActiveMenu(4)" [ngClass]="{'active': activeMenu == 4}" class="list-group-item">Zones {{activeMenu}}</li>-->
                <li (click)="changeActiveMenu(5)" [ngClass]="{'active': activeMenu == 5}" class="list-group-item">Commandes</li>
            </ul>
        </div>
    `
})
export class MenuComponent implements OnInit {
    ngOnInit(): void {
        this.getCurrentActiveMenu();
    }

    constructor(private router:Router) {}

    routes = [
        "/admin-manage-products",
        "/admin-manage-types",
        "/admin-manage-menus",
        "",
        "/admin-manage-orders"
    ]

    activeMenu: number;
    changeActiveMenu(newActive): void {
        //this.activeMenu = newActive;
        this.saveCurrentActiveMenu(newActive);
        this.router.navigate([this.routes[newActive-1]]);
    }

    saveCurrentActiveMenu(value:number) : void {
        localStorage.setItem('activeMenu', value.toString());
    }
    getCurrentActiveMenu() : void {
        if(localStorage.getItem('activeMenu') != null)
            this.activeMenu = parseInt(localStorage.getItem('activeMenu'));
        else
            this.activeMenu = 0;
    }
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/components/menu-component.ts